import React, { Fragment, useState } from "react";
import { Tabs, TabPanel } from "react-tabs";
import { Button, Form, FormGroup, Label } from "reactstrap";
import { useHistory } from "react-router-dom";
import { adminInstance } from "../../config/axios";
import { toast } from "react-toastify";
import "../../assets/styles/admin.css";
import moment from "moment";

const AddGiveawayForm = ({ payload, setPayload }) => {
  const history = useHistory();
  const [loading, setLoading] = useState(false);

  const handleChange = (key, value) => {
    setPayload({ ...payload, [key]: value });
  };

  const toLocalInput = (utcDate) => {
    if (!utcDate) return "";
    return moment(utcDate).local().format("YYYY-MM-DDTHH:mm");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (
      !payload.title ||
      !payload.prize ||
      !payload.endTime ||
      !payload.image ||
      !payload.winnerCount
    ) {
      toast.error("All fields are required");
      return;
    }
    try {
      let response;
      setLoading(true);
      const formData = new FormData();
      formData.append("title", payload.title);
      formData.append("endTime", moment(payload.endTime).utc().toISOString());
      formData.append("prize", payload.prize);
      formData.append("winnerCount", payload.winnerCount);

      if (payload.image instanceof File) {
        formData.append("image", payload.image);
      }

      if (payload._id) {
        response = await adminInstance().put(
          `/api/admin/updateGiveaway/${payload._id}`,
          formData,
        );
      } else {
        response = await adminInstance().post(
          "/api/admin/createGiveaway",
          formData,
        );
      }

      if (response.data.code === 201) {
        toast.success(response.data.message);
        history.push("/giveaway-management");
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error(error);
      toast.error("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setPayload({ ...payload, image: file });
    }
  };

  return (
    <Fragment>
      <Tabs>
        <TabPanel>
          <Form
            className="needs-validation user-add admin-type"
            onSubmit={handleSubmit}>
            {/* TITLE */}
            <FormGroup className="row mx-0">
              <div className="admin-input col-xl-5 col-md-7">
                <Label className="col-form-label pt-0">
                  <span>*</span> Title
                </Label>
                <input
                  className="form-control"
                  type="text"
                  value={payload?.title || ""}
                  name="title"
                  onChange={(e) => handleChange("title", e.target.value)}
                />
              </div>
            </FormGroup>

            <FormGroup className="row mx-0">
              <div className="admin-input col-xl-5 col-md-7">
                <Label className="col-form-label pt-0">
                  <span>*</span> Prize
                </Label>
                <input
                  className="form-control"
                  type="text"
                  value={payload?.prize || ""}
                  name="prize"
                  onChange={(e) => handleChange("prize", e.target.value)}
                />
              </div>
            </FormGroup>

            <FormGroup className="row mx-0">
              <div className="admin-input col-xl-5 col-md-7">
                <Label className="col-form-label pt-0">
                  <span>*</span> Winner Count
                </Label>
                <input
                  className="form-control"
                  type="text"
                  value={payload?.winnerCount || ""}
                  name="winnerCount"
                  onChange={(e) => handleChange("winnerCount", e.target.value)}
                />
              </div>
            </FormGroup>

            <FormGroup className="row mx-0">
              <div className="admin-input col-xl-5 col-md-7">
                <Label className="col-form-label pt-0">
                  <span>*</span> End Time
                </Label>
                <input
                  className="form-control"
                  type="datetime-local"
                  value={toLocalInput(payload.endTime)}
                  name="endTime"
                  onChange={(e) => handleChange("endTime", e.target.value)}
                />
              </div>
            </FormGroup>

            <FormGroup className="row justify-content-start mx-0">
              <div className="admin-intype col-xl-5 col-md-7">
                <Label className="col-form-label pt-0">Image</Label>

                <div className="file-upload">
                  <div className="file-select">
                    <div className="file-select-button">Choose File</div>
                    <div className="file-select-name">
                      {payload?.image instanceof File
                        ? payload.image.name
                        : payload?.image
                          ? payload.image.split("/").pop()
                          : "No file chosen..."}
                    </div>

                    <input
                      type="file"
                      accept="image/png, image/jpeg, image/jpg"
                      name="image"
                      onChange={handleImageChange}
                    />
                  </div>
                </div>
              </div>
            </FormGroup>

            <div className="form-button d-flex justify-content-start pt-3">
              <Button
                color="primary"
                type="submit"
                className="main-btn"
                disabled={loading}>
                {loading ? "Submitting..." : "Submit"}
              </Button>
            </div>
          </Form>
        </TabPanel>
      </Tabs>
    </Fragment>
  );
};

export default AddGiveawayForm;
